export enum CheckoutStrategyEnum {
  Eskolare = 'Eskolare',
  Bemobi = 'Bemobi'
}
